/**
 * Generates an object from a given text and variables.
 *
 * @param {string[]} text - The text array to parse and extract tags from.
 * @param {...(string | ((props: Record<string, any>) => string))} vars - The variables to replace in the text.
 * @returns {(props: Record<string, any>) => Record<string, string>} - Function that generates the object.
 */
const convertToObject = (
  text: string[],
  ...vars: Array<string | ((props: Record<string, any>) => string)>
) => {
  return (props: Record<string, any>): Record<string, string> => {
    const parsedTags = text.reduce((acc: string, item: string, i: number) => {
      let v: string = vars[i]?.toString() || ''

      // If it's a function, call it with props
      if (typeof vars[i] === 'function') {
        v = (vars[i] as (props: Record<string, any>) => string)(props)
      }

      // Merge with the rest
      return acc + item + v
    }, '')

    const rules = parsedTags
      .split(';')
      .map((item: string) => item.trim())
      .filter((item: string) => !!item)

    // Create and return the object
    return rules.reduce((acc: Record<string, string>, item: string) => {
      const [key, val] = item.split(':').map((i: string) => i.trim())
      return Object.assign(acc, { [key]: val })
    }, {})
  }
}
export default convertToObject

